import { useMutation } from 'react-query';
import { albumRequest } from 'src/models/gallery';
import { addAlbumPhotos, deleteAlbumPhoto } from 'src/services/gallery';

export default function useDeleteAlbumPhoto(albumId: number) {
  return useMutation((imageId: number) => deleteAlbumPhoto(albumId, imageId));
}
